import { render } from "./FooterPagesMenu.vue?vue&type=template&id=1540c2f0"
import script from "./FooterPagesMenu.vue?vue&type=script&lang=js"
export * from "./FooterPagesMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\eo-club-shop.lc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__